var collapsible_list_pair_default = {
  "container": "_3FJWR",
  "title": "_31V-g",
  "viewerContainer": "_3Ac6m",
  "titleContainer": "Pijcw",
  "expandIcon": "x5MxJ",
  "dndIcon": "tCcgf",
  "RTL": "M-uso",
  "LTR": "Yb6-0",
  "itemContainer": "F-Qcp",
  "itemContainerViewer": "_2bKBG",
  "mouseDown": "VYZ8v",
  "innerEditor": "zLHlM",
  "item": "qByfZ",
  "floatingAddPluginMenuWrapper": "Uz3nE",
  "childrenHidden": "zoWG7"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
